/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import MQTTWebsocket from './MQTTWebsocket';

export default class MQTTSubscription {
  topic : string;
  callback : (msg : any, topic? : string)=> any;
  MQTTWebsocket : MQTTWebsocket;
  id: string;
  constructor (topic, callback, MQTTWebsocket) {
    this.topic = topic;
    this.callback = callback;
    this.MQTTWebsocket = MQTTWebsocket;
    this.id = String(Math.floor(Math.random() * 1000000));
  }

  subscriptionReceivesMessageCallback (msg: any, topic: string) {
    this.callback(msg, topic);
  }

  unsubscribe () {
    this.MQTTWebsocket.unsubscribe(this.topic, this.id);
  }
}
